<template>
  <div class="index">
    <div class="index-con">
      <div class="login-con">
        <div class="index-title">Create an account</div>
        <div class="login-cons">
          <div class="login-center">
            <div class="login-list">
              <p class="login-title">Email*</p>
              <input type="text" v-model="email" />
            </div>
            <div class="login-list df">
              <p class="login-title">{{ $t("simpleRegTitle") }}*</p>
              <el-radio-group v-model="mytitle">
                <el-radio :label="'Prof.'">Prof.</el-radio>
                <el-radio :label="'Dr.'">Dr.</el-radio>
                <el-radio :label="'Mr.'">Mr.</el-radio>
                <el-radio :label="'Mrs.'">Mrs.</el-radio>
                <el-radio :label="'Ms.'">Ms.</el-radio>
              </el-radio-group>
            </div>
            <div class="login-list">
              <p class="login-title">{{ $t("simpleRegFirstname") }}*</p>
              <input type="text" v-model="Firstname" />
            </div>
            <div class="login-list">
              <p class="login-title">{{ $t("simpleRegLastname") }}*</p>
              <input type="text" v-model="lastname" />
            </div>
            <div class="login-list">
              <p class="login-title">{{ $t("simplePassword") }}*</p>
              <input type="password" v-model="password" :placeholder="$t('simplePasswordpic')" />
            </div>
            <div class="login-list">
              <p class="login-title">{{ $t("simpleRetypePassword") }}*</p>
              <input type="password" v-model="twoPsd" />
            </div>
            <div class="login-list">
              <p class="login-title">{{ $t("simpleCode") }}</p>
              <div class="d-flex">
                <input type="text" v-model="code" />
                <ValidCode @input="createValidCode" />
              </div>
            </div>
            <!--div class="login-btn" @click="regFn">Sign in</!div-->
            <div class="login-btn">Sign in</div>
            <div class="login-text">
              Already have an account?
              <span class="text-blue cup" @click="toLogin">Please login</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidCode from "./code.vue";

export default {
  components: {
    ValidCode,
  },
  data() {
    return {
      validCode: "",
      radio: 3,
      email: "", // "282@qq.com",
      mytitle: "Dr.", // "Dr.",
      firstname: "", // "aaa",
      lastname: "", // "bbb",
      password: "", // "cccddd",
      twoPsd: "", // "cccddd",
      code: "", // "1234",
      myCode: "", // "1234",
    };
  },
  methods: {
    createValidCode(data) {
      this.validCode = data;
      console.log(this.validCode, "-=-=-=");
    },
    toLogin() {
      this.$router.push("/login");
    },
    regFn() {
      if (!this.email) {
        this.$message.error(this.$t('simpleSignmsgemail'));
        return;
      }
      if (!this.firstname) {
        // this.$message.error(this.$t('simpleSignmsgFirstname'));
        // return;
      }
      if (!this.lastname) {
        this.$message.error(this.$t('simpleSignmsgLastname'));
        return;
      }
      if (!this.password) {
        this.$message.error(this.$t('simpleSignmsgPassword'));
        return;
      }
      if (!this.twoPsd) {
        this.$message.error(this.$t('simpleSignmsgRetypePassword'));
        return;
      }
      if (this.twoPsd != this.password) {
        this.$message.error(this.$t('simpleSignmsgPasswordinconsistency'));
        return;
      }
      if (this.password.length < 6 || this.password.length > 15) {
        this.$message.error(this.$t('simpleSignmsgpasswordpic'));
        return;
      }
      if (!this.code) {
        this.$message.error(this.$t('simpleSignmsgCode'));
        return;
      }
      if (this.code != this.validCode) {
        this.$message.error(this.$t('simpleSignmsgCodeinconsistency'));
        return;
      }
      var params = {
        Firstname: this.firstname,
        email: this.email,
        Lastname: this.lastname,
        password: this.password,
        mytitle: this.mytitle,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.register(params).then((res) => {
        console.log(res);
        loading.close();
        if (res.code == "200") {
          that.$message.success(this.$t('simpleSignmsgRegistrationsuccessful'));
          var con = res.data[0];
          localStorage.setItem("Firstname", con.Firstname);
          localStorage.setItem("Lastname", con.Lastname);
          localStorage.setItem("email", con.email);
          localStorage.setItem("mytitle", con.mytitle);
          localStorage.setItem("token", con.token);
          localStorage.setItem("visitor_id", con.visitor_id);
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 90px 20px 20px;
  box-sizing: border-box;
}

.df {
  display: flex;
  align-items: center;
}

.df .login-title {
  margin-right: 20px;
}

.login-center {
  width: 70%;
  margin: 0 auto;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
}

.login-list input {
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  color: #555;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.d-flex {
  display: flex;
}

.d-flex input {
  flex: 1;
  width: auto;
  margin-right: 20px;
}

.login-btn {
  /*color: #fff; 
  background-color: #428bca;
  */
  background-color: #ccc;
  color: #fff;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #428bca;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }

  .login-center {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/simpleReg.vue